import React from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'motion/react';
import { ArrowUpRight } from 'lucide-react';
import { services } from '../../data/site';
import { EASE_OUT } from '../../lib/motion';
import GlowingEffect from '../fx/GlowingEffect';

// Desktop mega menu under the header: one tile per service line, over a dimmed page
const ServicesMenu = ({ open, onEnter, onLeave, onNavigate }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        key="curtain"
        aria-hidden="true"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        onClick={onNavigate}
        className="absolute inset-x-0 top-full hidden h-screen bg-background/55 backdrop-blur-[3px] lg:block"
      />
    )}
    {open && (
      <motion.div
        key="panel"
        id="services-menu"
        initial={{ opacity: 0, y: -8, filter: 'blur(6px)' }}
        animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
        exit={{ opacity: 0, y: -8, filter: 'blur(6px)' }}
        transition={{ duration: 0.35, ease: EASE_OUT }}
        onMouseEnter={onEnter}
        onMouseLeave={onLeave}
        className="absolute inset-x-0 top-full hidden px-[var(--gutter)] pt-2 lg:block"
      >
        <div className="mx-auto grid max-w-[1440px] grid-cols-4 gap-2 rounded-[1.25rem] border border-border bg-card/95 p-2 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.5)] backdrop-blur-2xl">
          {services.map((service, i) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.slug}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: EASE_OUT, delay: 0.04 * i }}
                className="relative rounded-[1.1rem]"
              >
                <GlowingEffect spread={36} proximity={48} />
                <Link
                  to={service.path}
                  onClick={onNavigate}
                  className="group flex h-full flex-col rounded-[1.1rem] p-5 transition-colors hover:bg-foreground/[0.04]"
                >
                  <div className="flex items-center justify-between">
                    <span className="label text-brand-ink">({service.index})</span>
                    <ArrowUpRight size={16} className="text-muted-foreground transition-transform duration-500 ease-out-expo group-hover:rotate-45 group-hover:text-foreground" aria-hidden="true" />
                  </div>
                  <Icon size={22} strokeWidth={1.5} className="mt-8 text-brand" aria-hidden="true" />
                  <span className="title mt-4">{service.label}</span>
                  <span className="mt-2 line-clamp-3 text-sm leading-relaxed text-muted-foreground">{service.description}</span>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default ServicesMenu;
